import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=3ae1ad1e&"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHorizontal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports